import React from 'react'
import { RecentlyViewedItem } from '@plm-core/recently-viewed'
import getAttachmentUrl from '../utils/getAttachmentUrl'

const getImageUrl = ({ attachmentId }: { attachmentId: string }) => {
  return getAttachmentUrl({ attachmentId, size: 242 })
}

export const recentlyViewedEntityConfig = [
  {
    tabTitle: 'Products',
    resourceType: 'product',
    resourceData: `
      ... on Product {
        id
        description
        primaryAttachmentResourceId
        businessPartners {
          partner {
            id
            name
          }
        }
      }
    `,
    dataFilter: (resource: any) => !!resource?.description,
    getRowItemData: (contentItem: any, resource: any, dataSet: any) => (
      <RecentlyViewedItem
        imageUrl={getImageUrl({
          attachmentId: resource?.primaryAttachmentResourceId,
        })}
        title={resource?.description}
        id={contentItem?.id}
        navigateUrl={`/products/${contentItem?.id}`}
        markerText={resource?.businessPartners
          ?.map((businessPartner: any) => businessPartner?.partner?.name)
          .filter((name: string) => !!name)}
      />
    ),
  },
  // {
  //   tabTitle: 'Samples',
  //   entity: 'sample',
  //   getNavigationUrl: (contentItem: any) =>
  //     `/samples/${contentItem.resourceId}`,
  //   getRowItemData: (contentItem: any) => (
  //     <RecentlyViewedItem
  //       imageUrl={`/samples/${contentItem?.resourceId}`}
  //       title={contentItem?.name}
  //       id={contentItem?.number}
  //       markerText={contentItem?.organization?.name}
  //       footer={`${new Date(contentItem?.lastModifiedDate ?? '').toDateString()} ${
  //         contentItem?.organization?.name
  //       }`}
  //     />
  //   ),
  // },
]
